(function () {
  var KLAVIYO_REVISION = '2026-07-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function exchangeId(params) {
    var kx = params.get('_kx');
    if (kx) return kx;
    var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
    if (!m) return null;
    try {
      return JSON.parse(atob(decodeURIComponent(m[1])))['$exchange_id'] || null;
    } catch (e) {
      return null;
    }
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function init(root) {
    var cfg = root.dataset;
    var params = new URLSearchParams(window.location.search);
    var storeKey = 'mgm_concours_' + cfg.contest;
    var openAt = Date.parse(cfg.openAt);
    var closeAt = Date.parse(cfg.closeAt);
    var kx = exchangeId(params);
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-cv-card]'));
    var status = root.querySelector('[data-cv-status]');
    var countdown = root.querySelector('[data-cv-countdown]');
    var sheet = root.querySelector('[data-cv-sheet]');
    var panel = sheet.querySelector('.cv-sheet__panel');
    var form = root.querySelector('[data-cv-form]');
    var emailField = root.querySelector('[data-cv-email]');
    var errorEl = root.querySelector('[data-cv-error]');
    var selected = null;
    var lastFocus = null;

    document.body.appendChild(sheet);

    function phase() {
      var now = Date.now();
      if (!isNaN(openAt) && now < openAt) return 'before';
      if (!isNaN(closeAt) && now >= closeAt) return 'closed';
      return 'open';
    }

    function stored() {
      try {
        return JSON.parse(localStorage.getItem(storeKey) || 'null');
      } catch (e) {
        return null;
      }
    }

    function card(n) {
      return cards.filter(function (c) { return c.dataset.number === String(n); })[0] || null;
    }

    function fill(el, template, name) {
      el.textContent = template.replace('[nom]', name);
    }

    function renderStatus() {
      var p = phase();
      root.dataset.phase = p;
      status.hidden = false;
      status.querySelector('[data-cv-status-text]').textContent = p === 'before' ? cfg.beforeText : p === 'open' ? cfg.openText : cfg.closedText;
      if (p !== 'open') {
        countdown.textContent = '';
        return;
      }
      var s = Math.max(0, Math.floor((closeAt - Date.now()) / 1000));
      var d = Math.floor(s / 86400);
      countdown.textContent = (d ? d + ' j ' : '') + pad(Math.floor((s % 86400) / 3600)) + ' h ' + pad(Math.floor((s % 3600) / 60)) + ' min ' + pad(s % 60) + ' s';
    }

    function showDone(kind, name) {
      var done = root.querySelector('[data-cv-done]');
      var title = done.querySelector('[data-cv-done-title]');
      var text = done.querySelector('[data-cv-done-text]');
      title.textContent = title.dataset[kind];
      fill(text, text.dataset[kind], name);
      done.hidden = false;
    }

    function markVoted(n) {
      root.dataset.voted = 'true';
      cards.forEach(function (c) {
        c.classList.toggle('is-voted', c.dataset.number === String(n));
      });
    }

    function setError(msg) {
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }

    function view(name) {
      sheet.querySelectorAll('[data-cv-view]').forEach(function (el) {
        el.hidden = el.dataset.cvView !== name;
      });
    }

    function openSheet() {
      lastFocus = document.activeElement;
      sheet.hidden = false;
      document.documentElement.classList.add('cv-lock');
      requestAnimationFrame(function () {
        sheet.classList.add('is-open');
      });
      setTimeout(function () {
        var input = emailField.hidden ? null : emailField.querySelector('input');
        (input && window.matchMedia('(min-width: 750px)').matches ? input : panel).focus({ preventScroll: true });
      }, 60);
    }

    function closeSheet() {
      if (sheet.hidden) return;
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('cv-lock');
      setTimeout(function () { sheet.hidden = true; }, 320);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    function select(n) {
      var c = card(n);
      if (!c || phase() !== 'open' || stored()) return;
      selected = c;
      var pick = sheet.querySelector('[data-cv-pick-img]');
      pick.alt = c.dataset.name;
      if (c.dataset.photo) pick.src = c.dataset.photo;
      else pick.removeAttribute('src');
      sheet.querySelector('[data-cv-pick-num]').textContent = c.dataset.number;
      var title = sheet.querySelector('[data-cv-pick-title]');
      fill(title, title.dataset.template, c.dataset.name);
      sheet.querySelector('[data-cv-pick-caption]').textContent = c.dataset.caption || '';
      emailField.hidden = !!kx;
      setError('');
      view('confirm');
      openSheet();
    }

    function send(profile, n, name) {
      var body = {
        data: {
          type: 'event',
          attributes: {
            properties: { contest: cfg.contest, finalist: Number(n), finalist_name: name },
            metric: { data: { type: 'metric', attributes: { name: cfg.metric } } },
            profile: { data: { type: 'profile', attributes: profile } },
            unique_id: cfg.contest + ':' + (profile._kx || profile.email)
          }
        }
      };
      return fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(cfg.companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: KLAVIYO_REVISION },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (res.status === 202 || res.status === 200) return;
        return res.text().then(function (t) { throw new Error('Klaviyo ' + res.status + ' ' + t); });
      });
    }

    function vote(c, email) {
      var n = c.dataset.number;
      var name = c.dataset.name;
      var button = form.querySelector('button[type="submit"]');
      button.setAttribute('aria-busy', 'true');
      return send(email ? { email: email } : { _kx: kx }, n, name)
        .then(function () {
          try { localStorage.setItem(storeKey, JSON.stringify({ n: n, name: name })); } catch (e) {}
          if (email && window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email });
          markVoted(n);
          showDone('thanks', name);
          var thanks = sheet.querySelector('[data-cv-thanks-text]');
          fill(thanks, thanks.dataset.template, name);
          view('thanks');
        })
        .catch(function (err) {
          console.error('[concours]', err);
          if (!email && kx) {
            kx = null;
            emailField.hidden = false;
            emailField.querySelector('input').focus();
            return;
          }
          setError(cfg.errorGeneric);
        })
        .then(function () {
          button.removeAttribute('aria-busy');
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!selected) return;
      var email = null;
      if (!emailField.hidden) {
        var input = emailField.querySelector('input');
        email = input.value.trim().toLowerCase();
        if (!EMAIL_RE.test(email)) {
          input.setAttribute('aria-invalid', 'true');
          setError(cfg.errorEmail);
          input.focus();
          return;
        }
        input.removeAttribute('aria-invalid');
      }
      setError('');
      vote(selected, email);
    });

    cards.forEach(function (c) {
      c.querySelectorAll('[data-cv-vote]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          select(c.dataset.number);
        });
      });
    });

    sheet.querySelectorAll('[data-cv-close]').forEach(function (el) {
      el.addEventListener('click', closeSheet);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSheet();
    });

    renderStatus();
    if (phase() === 'open') setInterval(renderStatus, 1000);

    var previous = stored();
    if (previous) {
      markVoted(previous.n);
      showDone('already', previous.name);
    } else if (params.get('vote')) {
      select(params.get('vote'));
    }
  }

  function boot() {
    document.querySelectorAll('[data-cv]').forEach(function (root) {
      if (root.dataset.cvReady) return;
      root.dataset.cvReady = '1';
      init(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
